import { LANGUAGES, COMMODITIES } from "../data/constants";

// ============================================================
// LANGUAGE HELPERS
// ============================================================

/** Returns the CSS font string for a given language code. */
export function getLangFont(lang) {
  return LANGUAGES.find((l) => l.code === lang)?.font || "'DM Sans', sans-serif";
}

/** Returns the localized commodity name, falling back to English. */
export function getName(commodity, lang) {
  return commodity[lang] || commodity.en;
}

// ============================================================
// MOCK PRICE GENERATOR
// ============================================================

/**
 * Generates deterministic (date-seeded) mock prices for every
 * commodity for a given mandi name.
 */
export function generatePrices(mandi) {
  const seed = mandi.charCodeAt(0) + new Date().getDate();
  const r = (s) => ((Math.sin(s) * 10000) % 1 + 1) / 2;

  return COMMODITIES.map((c, i) => {
    const minP   = Math.round(c.base + (r(seed + i * 17) - 0.5) * c.v * 0.6);
    const maxP   = Math.round(minP + c.v * 0.3 + r(seed + i * 31) * c.v * 0.4);
    const modalP = Math.round((minP + maxP) / 2);
    const trend  = r(seed + i * 53) > 0.6 ? "up" : r(seed + i * 53) > 0.3 ? "down" : "same";

    return {
      ...c,
      minPrice:   minP,
      maxPrice:   maxP,
      modalPrice: modalP,
      trend,
      change: Math.round(r(seed + i * 11) * 200),
    };
  });
}

// ============================================================
// SHARED STYLE HELPERS
// ============================================================

/**
 * Returns inline styles for a `<select>` element.
 * @param {boolean} disabled – whether the select is disabled
 */
export const selectStyles = (disabled) => ({
  width:     "100%",
  padding:   "11px 14px",
  borderRadius: 10,
  border:    "1.5px solid #d1c7b0",
  background: "#fff",
  fontSize:  14,
  outline:   "none",
  cursor:    disabled ? "not-allowed" : "pointer",
  appearance: "none",
  opacity:   disabled ? 0.45 : 1,
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23666' stroke-width='1.5' fill='none'/%3E%3C/svg%3E")`,
  backgroundRepeat:   "no-repeat",
  backgroundPosition: "right 12px center",
});

/** Shared uppercase label style used across filter sections. */
export const FILTER_LABEL_STYLE = {
  display:       "block",
  fontSize:      11,
  fontWeight:    700,
  color:         "#555",
  marginBottom:  5,
  letterSpacing: 0.5,
  textTransform: "uppercase",
  fontFamily:    "'DM Sans', sans-serif",
};
